export default "__VITE_ASSET__3dbf5981__"